class Expandables {
    constructor() {

    }

    init() {


      //expandable content
      let expandables = $('.is-expandable > button');
      if(expandables.length) {

        expandables.each(function(i,expandable){
          // if($(expandable).is(':visible'))
          let input = $(this).prev('input').attr('id', 'expandable-'+i);
          let label = $(this).find('label').attr('for', 'expandable-'+i);
          $(expandable).on('click', function(e){
            let content = $(this).next('.is-expandable__content');
            let contentInner = content.find('.is-expandable__content-inner');
            if($(expandable).attr('aria-expanded') == 'false') {
              // console.log('aria-expanded false', content, contentInner.get(0).clientHeight);
              $(expandable).attr('aria-expanded', true);
              content.addClass('is-expanded');
              content.css('max-height', contentInner.get(0).clientHeight+$(expandable).get(0).clientHeight);
            } else {
              // console.log('aria-expanded true', content);
              $(this).attr('aria-expanded', false);
              content.removeClass('is-expanded');
              if(undefined !== content.attr('data-max-height') && content.attr('data-max-height') != '') {
                // console.log('max-height', content.attr('data-max-height'));
                // console.log('max-height', eval(content.attr('data-max-height')));
                // console.log('(expandable).get(0).clientHeight', $(expandable).get(0).clientHeight);
                content.css('max-height', eval(content.attr('data-max-height')));
              } else {
                content.css('max-height', '');
              }
            }
          })
        });


        const breakpoints = [320, 1024, 1280, 1440];

        const generateMatches = (breakpoints, cb) => breakpoints.map((breakpoint) => {
          const mql = window.matchMedia(`(min-width: ${breakpoint}px)`); // create a MediaQueryList

          // create the listener and return the handler, so it can be canceled
          return mql.addListener((e) => cb(e, breakpoint));
        });

        const myFunc = (e, breakpoint) => {
          this.resizeExpandables(breakpoint);
          // console.log(`${breakpoint}: ${e.matches}`);
        }

        const listeners = generateMatches(breakpoints, myFunc);

        $(window).on('resize', _.debounce(this._resize.bind(this), 400));
        this._resize();

      }

    }

    resizeExpandables(breakpoint){
      // console.log('resizeExpandables breakpoint', breakpoint, $(window).width());
      let expandables = $('.is-expandable > button');
      // console.log('expandables', expandables);
      expandables.each(function(i,expandable){
        let content = $(expandable).next('.is-expandable__content');
        let contentInner = content.find('.is-expandable__content-inner');
        let maxHeight = contentInner.get(0).clientHeight+$(expandable).get(0).clientHeight;

        if(breakpoint == 1024 && $(window).width() >= 1024) {
            //open and disable button
            // console.log('resizeExpandables open and disable button');
            $(expandable).attr('aria-expanded', true);
            $(expandable).closest('.is-expandable').addClass('is-expanded');
            content.addClass('is-expanded');
            content.css('max-height', contentInner.get(0).clientHeight+$(expandable).get(0).clientHeight);
            $(expandable).css('display', 'none');
        } else if(breakpoint == 1024 && $(window).width() < 1024) {
            $(expandable).css('display', '');
        }
        if(undefined !== content.attr('data-max-height') && content.attr('data-max-height') != '') {

          $(this).attr('aria-expanded', false);
          $(expandable).closest('.is-expandable').removeClass('is-expanded');
          content.removeClass('is-expanded');
          let newMaxHeight = eval(content.attr('data-max-height'));
          content.css('max-height', newMaxHeight);
        } else {
          content.css('max-height', '');
        }
      });

    }


    _resize() {

      // console.log('_resize', $(window).width());
      let expandables = $('.is-expandable > button');
      // console.log('expandables', expandables);
      expandables.each(function(i,expandable){
        let content = $(expandable).next('.is-expandable__content');
        let contentInner = content.find('.is-expandable__content-inner');
        if(undefined !== content.attr('data-max-height') && content.attr('data-max-height') != '') {
          let containerHeight = $(content).height();
          let contentHeight = contentInner.outerHeight(true)-parseInt(contentInner.css('margin-bottom'));
          // console.log('contentHeight', contentHeight, 'containerHeight', containerHeight, content.attr('data-max-height'), eval(content.attr('data-max-height')));
          //disable/enable button

          if($(window).width() >= 1024) {
            //open and disable button
            // console.log('_resize open and disable button');
            $(expandable).attr('aria-expanded', true);
            $(expandable).closest('.is-expandable').addClass('is-expanded');
            content.addClass('is-expanded');
            content.css('max-height', contentHeight);
            $(expandable).css('display', 'none');
          } else {

            if($(expandable).attr('aria-expanded') == 'false') {
              let newMaxHeight = eval(content.attr('data-max-height'));
              content.css('max-height', newMaxHeight);
            } else {
              content.css('max-height', containerHeight);
            }
            // if(contentHeight > containerHeight)
            $(expandable).css('display', (contentHeight > containerHeight) ? '' : 'none');
          }
        }
      });

    }
}

export { Expandables };
